import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AppConfigService } from "@master/core/dist/core";
import { BaseService } from "./base.service";

@Injectable({
  providedIn: "root",
})
export class EvaluateConditionsService extends BaseService {
  constructor(
    private http: HttpClient,
    public appConfigService: AppConfigService
  ) {
    super(appConfigService);
  }

  /**
   * Evaluate condition like sequelize sintaxis
   * @param data 
   * @param conditions 
   * @returns 
   */
  evaluateConditions(data: any,expression:any, inverse?:boolean): Promise<any> {    
    const url = this.getUrl()+'/utils/evaluate-expression'
    return this.http.post(url, {data, expression, inverse}).toPromise();
  }
}
